import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Alert, CircularProgress } from '@mui/material';
import CoefficientRuleForm, { buildPayload, validateForm } from './CoefficientRuleForm';

const EditCoefficientRuleDialog = ({ open, onClose, rule, onSave }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({});

  const handleClose = () => { if (loading) return; setError(''); onClose(); };

  const handleSubmit = async () => {
    setError('');
    const v = validateForm(formData);
    if (v) { setError(v); return; }
    setLoading(true);
    try {
      const payload = buildPayload(formData);
      const res = await fetch(`https://elnaf.fi/apiElnaf/api/coefficient_rules.php?id=${rule.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      if (res.ok && (data.result === 1 || data.success)) {
        await onSave();
      } else {
        setError(data.error || data.message || 'Failed to update rule');
      }
    } catch (e) {
      setError('Network error — please try again');
    } finally {
      setLoading(false);
    }
  };

  if (!rule) return null;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ borderBottom: '1px solid #e5e7eb', fontWeight: 600 }}>
        Edit Coefficient Rule
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <CoefficientRuleForm initialData={rule} onChange={setFormData} />
      </DialogContent>
      <DialogActions sx={{ borderTop: '1px solid #e5e7eb', p: 2 }}>
        <Button onClick={handleClose} disabled={loading}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading}
          startIcon={loading && <CircularProgress size={20} color="inherit" />}
          sx={{ backgroundColor: '#845adf', '&:hover': { backgroundColor: '#6c48c5' } }}
        >
          {loading ? 'Saving...' : 'Save Changes'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCoefficientRuleDialog;
